document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const searchResults = document.getElementById("search-results");

  if (!searchInput || !searchResults) {
    return;
  }

  const hiddenProductTitleFragments = [
    "personalized logo fee",
    "personalisation fee(message inside/outside box and logo)",
    "personalisation fee(message inside and outside box)",
    "message inside box only",
    "message outside box only",
    "messages both inside and outside",
  ];

  const hiddenProductHandleFragments = [
    "personalized-logo-fee",
    "personalisation-fee-message-inside-outside-box-and-logo",
    "personalisation-fee-message-inside-and-outside-box",
    "message-inside-box-only",
    "message-outside-box-only",
    "messages-both-inside-and-outside",
  ];

  const hiddenLegacyProductIds = new Set([
    10784157008206,
    15710171234638,
    10495648203086,
    10773350285646,
    10775283827022,
    10775286710606,
    10804915306830,
    10804944896334,
    10813289234766,
    10784156778830,
    10495648006478,
    10495647940942,
    10799963078990,
    10799962882382,
    10799962718542,
    10799962685774,
    10799962390862,
    10799961964878,
  ]);

  function isHiddenPersonalisationProduct(product) {
    const productId = Number(product.id);
    const productTitle = (product.title || "").toLowerCase();
    const productHandle = (product.handle || "").toLowerCase();
    const productTags = Array.isArray(product.tags)
      ? product.tags.map((tag) => String(tag).toLowerCase())
      : String(product.tags || "")
          .toLowerCase()
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean);

    if (hiddenLegacyProductIds.has(productId)) return true;
    if (productTags.includes("hidden-personalisation-fee")) return true;
    if (hiddenProductTitleFragments.some((fragment) => productTitle.includes(fragment))) return true;
    if (hiddenProductHandleFragments.some((fragment) => productHandle.includes(fragment))) return true;

    return false;
  }

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();
    if (query.length < 2) {
      searchResults.innerHTML = "";
      searchResults.style.display = "none";
      return;
    }

    fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
      .then((response) => response.json())
      .then((data) => {
        let resultsHtml = "";
        const visibleProducts = (data.resources.results.products || []).filter(
          (product) => !isHiddenPersonalisationProduct(product)
        );

        if (visibleProducts.length > 0) {
          resultsHtml = "<ul>";
          visibleProducts.forEach((product) => {
            resultsHtml += `
              <li>
                <a href="${product.url}">
                  <img src="${product.image}" alt="${product.title}" width="40" height="40">
                  ${product.title}
                </a>
              </li>
            `;
          });
          resultsHtml += "</ul>";
        } else {
          resultsHtml = "<p>No results found</p>";
        }

        searchResults.innerHTML = resultsHtml;
        searchResults.style.display = "block";
      })
      .catch((error) => console.error("Error fetching search results:", error));
  });

  // Hide results when clicking outside
  document.addEventListener("click", function (event) {
    if (!searchInput.contains(event.target) && !searchResults.contains(event.target)) {
      searchResults.style.display = "none";
    }
  });
});
